import { defineMessages } from 'react-intl';

export default defineMessages({
  unitsString: {
    id: 'units',
    description: 'units',
    defaultMessage: 'units',
  },
  quantityString: {
    id: 'quantityCapital',
    description: 'Quantity',
    defaultMessage: 'Quantity',
  },
  designPackageString: {
    id: 'template.designPackage',
    description: 'design package',
    defaultMessage: 'Design Combination',
  },
  designPriceString: {
    id: 'template.designPrice',
    description: 'design price',
    defaultMessage: 'Design Price',
  },
  priceBrandString: {
    id: 'model.priceBand',
    description: 'price band',
    defaultMessage: 'Price Band',
  },
  totalPriceString: {
    id: 'template.totalPrice',
    description: 'total price',
    defaultMessage: 'Total Price',
  },
  suggestedString: {
    id: 'template.suggested',
    description: 'suggested',
    defaultMessage: 'Suggested',
  },
  priorityHeader: {
    id: 'template.priorityHeader',
    description: 'priority header',
    defaultMessage: 'Priority',
  },
  currency: {
    id: 'currency',
    description: 'USD',
    defaultMessage: 'USD',
  },
  noSubmittedTemplatesNotice: {
    id: 'noSubmittedTemplates',
    description: 'No templates have been submitted for this option cluster',
    defaultMessage: 'No templates have been submitted for this option cluster',
  },
  noInReviewTemplatesNotice: {
    id: 'noInReviewTemplates',
    description: 'No templates in review for this option cluster',
    defaultMessage: 'No templates for this option cluster in current workspace',
  },
  findMore: {
    id: 'findMore',
    description: 'Find More',
    defaultMessage: 'Find',
  },
  noSearchResultsNotice: {
    id: 'noSearchResultsNotice',
    description: 'No templates match the chosen search criteria',
    defaultMessage: 'No templates match the chosen search criteria',
  },
});
